// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file chat/v3/chat.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Prompt } from "./chat_prompt_pb";
import { file_chat_v3_chat_prompt } from "./chat_prompt_pb";
import type { Message as Message$1 } from "./chat_messages_pb";
import { file_chat_v3_chat_messages } from "./chat_messages_pb";
import type { AuditMetadata } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Recording } from "./chat_recording_pb";
import { file_chat_v3_chat_recording } from "./chat_recording_pb";
import type { Realm } from "../../realm/v3/realm_pb";
import { file_realm_v3_realm } from "../../realm/v3/realm_pb";
import type { LanguageRegion } from "../../i18n/v3/language_regions_pb";
import { file_i18n_v3_language_regions } from "../../i18n/v3/language_regions_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat.proto.
 */
export const file_chat_v3_chat: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chat_v3_chat_prompt, file_chat_v3_chat_messages, file_common_v3_common, file_chat_v3_chat_recording, file_realm_v3_realm, file_i18n_v3_language_regions, file_google_protobuf_timestamp]);

/**
 * @generated from message chat.v3.ChatRequest
 */
export type ChatRequest = Message<"chat.v3.ChatRequest"> & {
  /**
   * @generated from field: chat.v3.Prompt prompt = 1;
   */
  prompt: Prompt;
};

/**
 * Describes the message chat.v3.ChatRequest.
 * Use `create(ChatRequestSchema)` to create a new message.
 */
export const ChatRequestSchema: GenMessage<ChatRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 0);

/**
 * @generated from message chat.v3.ChatResponse
 */
export type ChatResponse = Message<"chat.v3.ChatResponse"> & {
  /**
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.ChatResponse.
 * Use `create(ChatResponseSchema)` to create a new message.
 */
export const ChatResponseSchema: GenMessage<ChatResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 1);

/**
 * @generated from message chat.v3.StreamRequest
 */
export type StreamRequest = Message<"chat.v3.StreamRequest"> & {
  /**
   * @generated from field: chat.v3.Prompt prompt = 1;
   */
  prompt: Prompt;
};

/**
 * Describes the message chat.v3.StreamRequest.
 * Use `create(StreamRequestSchema)` to create a new message.
 */
export const StreamRequestSchema: GenMessage<StreamRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 2);

/**
 * @generated from message chat.v3.StreamResponse
 */
export type StreamResponse = Message<"chat.v3.StreamResponse"> & {
  /**
   * The ID of the workflow processing this stream
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Message(s) in this response
   *
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.StreamResponse.
 * Use `create(StreamResponseSchema)` to create a new message.
 */
export const StreamResponseSchema: GenMessage<StreamResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 3);

/**
 * @generated from message chat.v3.ConversationRequest
 */
export type ConversationRequest = Message<"chat.v3.ConversationRequest"> & {
  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * The number of most recent messages to fully populate
   *
   * @generated from field: int64 recent_messages_count = 2;
   */
  recentMessagesCount: bigint;

  /**
   * Cursor for loading older messages: the server populates the requested
   * number of messages immediately older than this one instead of the most
   * recent. Empty loads the tail.
   *
   * @generated from field: optional string before_message_id = 3;
   */
  beforeMessageId?: string;
};

/**
 * Describes the message chat.v3.ConversationRequest.
 * Use `create(ConversationRequestSchema)` to create a new message.
 */
export const ConversationRequestSchema: GenMessage<ConversationRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 4);

/**
 * @generated from message chat.v3.ConversationResponse
 */
export type ConversationResponse = Message<"chat.v3.ConversationResponse"> & {
  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string publication_status = 3;
   */
  publicationStatus: string;

  /**
   * @generated from field: i18n.v3.LanguageRegion language_region = 4;
   */
  languageRegion: LanguageRegion;

  /**
   * @generated from field: common.v3.AuditMetadata audit_metadata = 5;
   */
  auditMetadata?: AuditMetadata;

  /**
   * @generated from field: realm.v3.Realm realm = 6;
   */
  realm?: Realm;

  /**
   * @generated from field: repeated chat.v3.Recording messages = 7;
   */
  messages: Recording[];

  /**
   * Active streaming info (present if a message is currently streaming)
   *
   * @generated from field: optional chat.v3.StreamingState streaming_state = 8;
   */
  streamingState?: StreamingState;

  /**
   * @generated from field: optional bool has_branches = 9;
   */
  hasBranches?: boolean;

  /**
   * Resource-visibility access level: project, restricted, or private. Distinct
   * from publication_status, which is the public-link axis.
   *
   * @generated from field: string visibility = 10;
   */
  visibility: string;

  /**
   * Whether the caller may change the chat's visibility (creator or project
   * Owner). Drives showing the visibility controls client-side.
   *
   * @generated from field: bool can_manage_visibility = 11;
   */
  canManageVisibility: boolean;

  /**
   * Total non-deleted messages in the chat, so the client can tell whether
   * older messages remain to load.
   *
   * @generated from field: int64 total_message_count = 12;
   */
  totalMessageCount: bigint;
};

/**
 * Describes the message chat.v3.ConversationResponse.
 * Use `create(ConversationResponseSchema)` to create a new message.
 */
export const ConversationResponseSchema: GenMessage<ConversationResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 5);

/**
 * StreamingState contains information about an active streaming session.
 * This is used to enable stream reconnection when users refresh the page.
 *
 * @generated from message chat.v3.StreamingState
 */
export type StreamingState = Message<"chat.v3.StreamingState"> & {
  /**
   * The messageID that is currently streaming
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: string active_message_id = 1;
   */
  activeMessageId: string;

  /**
   * When streaming started
   *
   * @generated from field: google.protobuf.Timestamp started_at = 2;
   */
  startedAt?: Timestamp;
};

/**
 * Describes the message chat.v3.StreamingState.
 * Use `create(StreamingStateSchema)` to create a new message.
 */
export const StreamingStateSchema: GenMessage<StreamingState> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 6);

/**
 * @generated from message chat.v3.StreamPlaybackRequest
 */
export type StreamPlaybackRequest = Message<"chat.v3.StreamPlaybackRequest"> & {
  /**
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: float playback_speed = 2;
   */
  playbackSpeed: number;

  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 3;
   */
  chatId: string;

  /**
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string tenant_id = 4;
   */
  tenantId: string;
};

/**
 * Describes the message chat.v3.StreamPlaybackRequest.
 * Use `create(StreamPlaybackRequestSchema)` to create a new message.
 */
export const StreamPlaybackRequestSchema: GenMessage<StreamPlaybackRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 7);

/**
 * @generated from message chat.v3.StreamPlaybackResponse
 */
export type StreamPlaybackResponse = Message<"chat.v3.StreamPlaybackResponse"> & {
  /**
   * The ID of the workflow processing this stream
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Message(s) in this response
   *
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.StreamPlaybackResponse.
 * Use `create(StreamPlaybackResponseSchema)` to create a new message.
 */
export const StreamPlaybackResponseSchema: GenMessage<StreamPlaybackResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 8);

/**
 * @generated from message chat.v3.ListRecentChatsRequest
 */
export type ListRecentChatsRequest = Message<"chat.v3.ListRecentChatsRequest"> & {
  /**
   * Number of chats to return per page (default: 100, max: 1000)
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Optional cursor for pagination — opaque RFC3339 timestamp returned as
   * next_cursor on the previous response. Empty on the first page.
   *
   * @generated from field: string cursor = 2;
   */
  cursor: string;
};

/**
 * Describes the message chat.v3.ListRecentChatsRequest.
 * Use `create(ListRecentChatsRequestSchema)` to create a new message.
 */
export const ListRecentChatsRequestSchema: GenMessage<ListRecentChatsRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 9);

/**
 * @generated from message chat.v3.ListRecentChatsResponse
 */
export type ListRecentChatsResponse = Message<"chat.v3.ListRecentChatsResponse"> & {
  /**
   * @generated from field: repeated chat.v3.ChatSummary chats = 1;
   */
  chats: ChatSummary[];

  /**
   * Cursor for next page (empty if no more pages)
   *
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;

  /**
   * Total count of chats for the user
   *
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * Describes the message chat.v3.ListRecentChatsResponse.
 * Use `create(ListRecentChatsResponseSchema)` to create a new message.
 */
export const ListRecentChatsResponseSchema: GenMessage<ListRecentChatsResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 10);

/**
 * @generated from message chat.v3.ChatSummary
 */
export type ChatSummary = Message<"chat.v3.ChatSummary"> & {
  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: common.v3.AuditMetadata audit_metadata = 3;
   */
  auditMetadata?: AuditMetadata;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * Last modification timestamp
   *
   * @generated from field: google.protobuf.Timestamp modified_at = 5;
   */
  modifiedAt?: Timestamp;

  /**
   * Resource-visibility access level: project, restricted, or private.
   *
   * @generated from field: string visibility = 6;
   */
  visibility: string;
};

/**
 * Describes the message chat.v3.ChatSummary.
 * Use `create(ChatSummarySchema)` to create a new message.
 */
export const ChatSummarySchema: GenMessage<ChatSummary> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 11);

/**
 * @generated from message chat.v3.InterruptChatRequest
 */
export type InterruptChatRequest = Message<"chat.v3.InterruptChatRequest"> & {
  /**
   * The ID of the message to interrupt
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: string message_id = 1;
   */
  messageId: string;
};

/**
 * Describes the message chat.v3.InterruptChatRequest.
 * Use `create(InterruptChatRequestSchema)` to create a new message.
 */
export const InterruptChatRequestSchema: GenMessage<InterruptChatRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 12);

/**
 * @generated from message chat.v3.InterruptChatResponse
 */
export type InterruptChatResponse = Message<"chat.v3.InterruptChatResponse"> & {
  /**
   * Whether the interrupt was successful
   *
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message chat.v3.InterruptChatResponse.
 * Use `create(InterruptChatResponseSchema)` to create a new message.
 */
export const InterruptChatResponseSchema: GenMessage<InterruptChatResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 13);

/**
 * Format defines the format of the conversation.
 *
 * @generated from enum chat.v3.Format
 */
export enum Format {
  /**
   * @generated from enum value: FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FORMAT_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: FORMAT_RICH_TEXT = 2;
   */
  RICH_TEXT = 2,
}

/**
 * Describes the enum chat.v3.Format.
 */
export const FormatSchema: GenEnum<Format> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat, 0);

/**
 * ChatService provides methods for creating, continuing, and retrieving
 * conversations.
 *
 * @generated from service chat.v3.ChatService
 */
export const ChatService: GenService<{
  /**
   * Stream creates or advances a conversation by accepting a prompt and
   * streaming updates as messages are completed.
   *
   * The prompt can be a text or a rich text document. When streaming
   * rich-text delta updates may be sent to allow the client render incremental
   * progress until the message (or block) is done. In such cases, the done
   * message will contain the rich-text document with all the updates applied.
   *
   * To create a new chat, provide a empty string or zero ID for the
   * parent message (example: "message_00000000000000000000").
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.Stream
   */
  stream: {
    methodKind: "server_streaming";
    input: typeof StreamRequestSchema;
    output: typeof StreamResponseSchema;
  },
  /**
   * Conversation retrieves a conversation by its ID. Clients may request either
   * a text or a rich text document. Conversations that were in rich-text
   * may be requested as text; however, messages that occurred as text will
   * be returned as text even if the caller asks for rich-text in this
   * request.
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.Conversation
   */
  conversation: {
    methodKind: "unary";
    input: typeof ConversationRequestSchema;
    output: typeof ConversationResponseSchema;
  },
  /**
   * StreamPlayback retrieves a message by its ID and streams it back to the
   * client. This is useful for playback of messages that were previously
   * streamed. The client can specify a playback speed to control how fast the
   * message is played back. The playback speed is a multiplier of the original
   * message speed, where 1.0 is the original speed, 0.5 is half speed, and 2.0
   * is double speed.
   *
   * This method is useful for debugging and demonstration purposes.
   *
   * @generated from rpc chat.v3.ChatService.StreamPlayback
   */
  streamPlayback: {
    methodKind: "server_streaming";
    input: typeof StreamPlaybackRequestSchema;
    output: typeof StreamPlaybackResponseSchema;
  },
  /**
   * ListRecentChats retrieves a paginated list of recent chats for the authenticated user,
   * sorted by most recent first. Returns chat metadata including ID, title,
   * created date, and last modified date.
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.ListRecentChats
   */
  listRecentChats: {
    methodKind: "unary";
    input: typeof ListRecentChatsRequestSchema;
    output: typeof ListRecentChatsResponseSchema;
  },
  /**
   * InterruptChat interrupts an active chat session/workflow.
   * This is typically called when the user clicks the stop button during streaming.
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.InterruptChat
   */
  interruptChat: {
    methodKind: "unary";
    input: typeof InterruptChatRequestSchema;
    output: typeof InterruptChatResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chat_v3_chat, 0);

